// tslint:disable:max-line-length
import { Form, Select, Spin } from 'antd';
import autobind from 'autobind-decorator';
import { isArrayLike } from 'mobx';
import React from 'react';
import { ObjectUtils } from 'src/core/utils/object';

const FormItem = Form.Item;
const Option = Select.Option;

interface DropdownProps {
	request?: DropdownRequest<any>;
	keyField?: string;
	textField?: string;
	model?: any;
	options?: any[];
	required?: boolean;
	disabled?: boolean;
	//searchable?: boolean;
	label: string;
	description?: string;
	onChanged?: (item: any) => void;
	multi?: boolean;
	placeholder?: string;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
	afterLoad?: (selectedOptions: any, options: any[]) => void;
	cascadeValue?: any;
	cascadeField?: string;
	cascadeFiltertype?: string
	allowNewTags?: boolean;
	optionRenderer?: (item: any) => React.ReactNode;
	dropdownRender?: (menu) => React.ReactNode;
	disableOption?: (item: any) => boolean;
	filters?: any[];
	readOnly?: boolean;
}

interface DropdownState {
	options?: any[];
	complete?: boolean;
	selectedOptions?: any;
	errors: ValidationError[];
	fetching?: boolean
	value?: any;
}

export class DropdownView extends React.Component<DropdownProps, DropdownState> {
	private keyField: string;
	private textField: string;
	private _isMounted = false;
	private timer: number;

	constructor(props) {
		super(props);
		this.state = {
			errors: []
		};
	}

	private config(value: any, cascadeValue?: any, cascadeField?: string, cascadeFilterType?: string) {
		this.internalSetState({ value });
		if (this.props.request) {
			// TODO: Pending check...
			if (cascadeField) {
				if (cascadeValue != null) {

					this.props.request.dataSet.addFilter(cascadeField, 'eq', cascadeValue, cascadeFilterType);

				} else {

					this.props.request.dataSet.removeFilter(cascadeField, cascadeFilterType);
				}
			}

			if (value != null && (!isArrayLike(value) || value.length !== 0)) {
				const values = isArrayLike(value) ? value : [value];
				const predicate = values.reduce((prev, curr) => (prev ? `${prev} || ` : '') + `it.${this.keyField} == ${JSON.stringify(curr)}`, null);
				const sortingCriteria = `it.${this.keyField}`;
				const hasSorting = this.props.request.dataSet.hasSorting(this.keyField);
				this.props.request.dataSet
					.load(function (queryable) {
						if (!hasSorting) {
							queryable = queryable.orderBy(sortingCriteria);
						}
						return queryable.filter(predicate);
					})
					.then((items) => {
						this.internalSetState({
							selectedOptions: this.props.multi || this.props.allowNewTags
								? items.slice()
								: items.length > 0
									? items[0]
									: null
						});
						this.loadOptions(this.props.request.query);
					});
			} else {
				this.internalSetState({
					selectedOptions: this.props.multi || this.props.allowNewTags
						? []
						: null
				});
				this.loadOptions(this.props.request.query);
			}
		} else {

			let selectedOpts;

			if (value != null) {
				if (isArrayLike(value)) {
					selectedOpts = value.map((item) => this.props.options.find((e) => e[this.keyField] === item) || { [this.keyField]: item, [this.textField]: item });
				} else {
					selectedOpts = this.props.options.find((o) => o[this.keyField] === value) || { [this.keyField]: value, [this.textField]: value };
				}
			}

			this.internalSetState({
				options: this.props.options.slice(),
				selectedOptions: selectedOpts,
				complete: true
			});
		}
	}

	@autobind
	private async loadOptions(request: () => Promise<any>): Promise<void> {
		if (this._isMounted === true) {
			this.internalSetState({ fetching: true });
			await request();
			this.internalSetState({
				fetching: false,
				options: this.props.request.dataSet.items.slice(),
				complete: this.props.request.dataSet.currentPage === this.props.request.dataSet.totalPages
			});

			if (this.props.afterLoad != null) {
				this.props.afterLoad(this.state.selectedOptions, this.state.options);
			}
		}
	}

	@autobind
	private async appendOptions(request: () => Promise<any>): Promise<void> {
		if (this._isMounted == true) {
			this.internalSetState({ fetching: true });
			await request();
			this.internalSetState({
				fetching: false,
				options: this.state.options.concat(this.props.request.dataSet.items.slice()),
				complete: this.props.request.dataSet.currentPage === this.props.request.dataSet.totalPages
			});

			if (this.props.afterLoad != null) {
				this.props.afterLoad(this.state.selectedOptions, this.state.options);
			}
		}
	}

	componentWillUnmount() {
		this._isMounted = false;
		if (this.timer) {
			clearTimeout(this.timer);
		}
	}

	componentDidMount() {
		let model = null;
		this._isMounted = true;
		if (this.props.model != null) {
			if (this.props.allowNewTags) {
				model = isArrayLike(this.props.model) ? this.props.model.map(m => m.toString()) : this.props.model.toString();
			} else {
				model = isArrayLike(this.props.model) ? this.props.model.slice() : this.props.model;
			}
		} else if (this.props.allowNewTags || this.props.multi) {
			model = [];
		}

		this.keyField = this.props.keyField || 'value';
		this.textField = this.props.textField || 'label';

		this.config(model, this.props.cascadeValue, this.props.cascadeField, this.props.cascadeFiltertype);
	}

	updateModel(props: Readonly<DropdownProps>) {
		this.keyField = props.keyField || this.keyField || 'value';
		this.textField = props.textField || this.textField || 'label';
		let model;
		if (props.model != null) {
			if (this.props.allowNewTags) {
				model = isArrayLike(props.model) ? props.model.map(m => m.toString()) : props.model.toString();
			} else {
				model = isArrayLike(props.model) ? props.model.slice() : props.model;
			}

		} else if (this.props.allowNewTags || this.props.multi) {
			model = [];
		}
		if (model != null && this.state.value != null && !ObjectUtils.equals(model, this.state.value)) {
			if (this.state.options) {
				const selected = this.state.options.find((e) => e[this.keyField] === model);
				if (selected != null) {
					this.internalSetState({ value: model });
				} else {
					this.config(model, props.cascadeValue, props.cascadeField, props.cascadeFiltertype);
				}
			}
		}
		if (!ObjectUtils.equals(this.props.cascadeValue, props.cascadeValue) || !ObjectUtils.equals(this.props.filters, props.filters)) {
			this.config(model, props.cascadeValue, props.cascadeField, props.cascadeFiltertype);
		}
		if (props.model == null) {
			this.internalSetState({ value: undefined, selectedOptions: undefined });
		}
	}
	componentWillReceiveProps(nextProps: Readonly<DropdownProps>, nextContext: any): void {
		if (nextProps.request == null && nextProps.options !== this.state.options) {
			this.internalSetState({
				options: nextProps.options
			}, () => {
				this.updateModel(nextProps);
			});
		}
		else {
			this.updateModel(nextProps);
		}
	}
	render() {
		const { value, selectedOptions, fetching } = this.state;
		let { optionRenderer, disableOption, readOnly, dropdownRender, placeholder, disabled } = this.props;
		let options = this.state.options;

		if (selectedOptions) {
			if (options) {
				if (isArrayLike(selectedOptions)) {
					options = selectedOptions.filter(e => options.every(o => o[this.keyField] !== e[this.keyField])).concat(options);
				} else if (options.every(e => e[this.keyField] !== selectedOptions[this.keyField])) {
					options = [selectedOptions].concat(options);
				}
			} else {
				options = this.props.multi ? selectedOptions : [selectedOptions];
			}
		}

		if (options == null) {
			return null;
		}

		if (optionRenderer == null) {
			optionRenderer = (item) => item[this.textField];
		}

		let items = options.map((item) => (
			<Option title={item[this.textField]} key={item[this.keyField]} value={item[this.keyField]} disabled={disableOption ? disableOption(item) : false}>{optionRenderer(item)}</Option>
		));

		if (fetching) {
			items = [<Option key='disabled' disabled><Spin size='small' /></Option>, ...items];
		}

		const selectProps = {
			placeholder,
			style: { width: '100%' },
			onChange: this.onChange,
			allowClear: !this.props.required,
			value,
			disabled: disabled,
			onPopupScroll: this.onScroll,
			defaultActiveFirstOption: false,
			optionLabelProp: "title",
			dropdownRender,
		};

		if (this.props.multi) {
			selectProps['mode'] = 'multiple';
		}

		if (this.props.allowNewTags) {
			selectProps['mode'] = 'tags';
		}

		selectProps['showSearch'] = true;
		selectProps['filterOption'] = (input, option) => {
			input = input.toLowerCase();
			if (option.type.isSelectOption) {
				return this.props.request || (option.props.children && option.props.children.toLowerCase().indexOf(input) > - 1);
			}

			return options.some(m => m[this.textField].toLowerCase() === input);
		};
		selectProps['onSearch'] = this.inputChange;
		selectProps['onBlur'] = () => this.inputChange('');

		const select = React.createElement(Select as any, selectProps, items);

		const hasErrors = this.state.errors.length !== 0 || (this.props.required && this.isEmpty());

		let message = this.props.description;

		if (hasErrors) {
			if (this.props.required && this.isEmpty()) {
				message = 'Required';
			} else {
				message = 'Something is wrong' // TODO: message = this.state.errors.map(e => e.text).join(", ")
			}
		}

		return (
			<FormItem
				label={this.props.label}
				required={this.props.required}
				validateStatus={hasErrors ? 'error' : 'success'}
				help={message}
			>
				<div onMouseDown={e => e.preventDefault()}>
					{!readOnly && select}
					{readOnly && this.renderReadOnly(options)}
				</div>
			</FormItem>
		);
	}
	@autobind
	private async onChange(selection) {
		if (selection == null) {
			let val;
			if (this.props.multi || this.props.allowNewTags) {
				val = [];
			} else {
				val = null;
			}

			if (this.props.onChanged) {
				this.props.onChanged(val);
			}

			if (this.props.onGetErrorMessage != null) {
				const errors = await this.props.onGetErrorMessage();
				this.internalSetState({
					value: val,
					selectedOptions: val,
					errors: errors
				});
			} else {
				this.internalSetState({
					value: val,
					selectedOptions: val
				});
			}
		} else {
			let val = selection;
			if (isArrayLike(selection)) {
				val = selection.map((item) => this.state.options.find((e) => e[this.keyField] === item) ||
					this.state.selectedOptions && this.state.selectedOptions.find((e) => e[this.keyField] === item) ||
					{ [this.keyField]: item, [this.textField]: item });
			} else {
				val = this.state.options.find((o) => o[this.keyField] === selection) ||
					this.state.selectedOptions && [this.state.selectedOptions].find((o) => o[this.keyField] === selection) ||
					{ [this.keyField]: selection, [this.textField]: selection };
			}
			if (this.props.onChanged) {
				this.props.onChanged(val);
			}
			if (this.props.onGetErrorMessage != null) {
				const errors = await this.props.onGetErrorMessage();
				this.internalSetState({
					value: selection,
					selectedOptions: val,
					errors: errors
				});
			} else {
				this.internalSetState({
					value: selection,
					selectedOptions: val
				});
			}
		}
	}

	@autobind
	private inputChange(inputValue: string) {
		if (this.props.request) {
			if (inputValue !== this.props.request.dataSet.searchKeywords) {
				if (this.timer) {
					clearTimeout(this.timer);
				}
				this.timer = setTimeout(this.inputChanged, 300, inputValue) as any;
			} else {
				this.internalSetState({
					options: this.props.request.dataSet.items.slice(),
					complete: this.props.request.dataSet.currentPage === this.props.request.dataSet.totalPages
				})
			}
		}
	}

	private inputChanged = (inputValue: string) => {
		this.props.request.dataSet.searchKeywords = inputValue;
		this.loadOptions(this.props.request.dataSet.firstPage);
	}

	@autobind
	private onScroll(e) {
		if (!this.state.fetching && !this.state.complete && e.target.scrollTop + e.target.clientHeight + 5 >= e.target.scrollHeight) {
			this.appendOptions(this.props.request.dataSet.nextPage);
		}
	}

	isEmpty = (): boolean => {
		if (this.state.value == null) { return true; }
		return isArrayLike(this.state.value) && this.state.value.length === 0;
	}

	private internalSetState<K extends keyof DropdownState>(
		state: Pick<DropdownState, K> | ((prevState: Readonly<DropdownState>, props: Readonly<DropdownProps>) => (Pick<DropdownState, K> | DropdownState | null)),
		callback?: () => void
	) {
		if (this._isMounted) {
			this.setState(state, callback);
		}
	}

	private renderReadOnly = (options: any[]) => {
		return <p>{options.map(item => <strong>{item[this.textField]}</strong>)}</p>
	}
}



// WEBPACK FOOTER //
// ./src/core/ui/dropdown.view.tsx